import React from 'react';
import { Outlet } from 'react-router-dom';

const Fulfillment: React.FC = () => {

  return (
    <div className="flex h-full">
      {/* Sidebar */}
{/*       <div className="w-64 bg-white shadow-sm p-4">
        <h2 className="text-xl font-semibold mb-4 text-custom-blue">Bodega</h2>
        <nav className="space-y-2">
          {hasPermission('manage_empacado') && (
            <Link
              to="/bodega/empacado"
              className={`flex items-center p-2 rounded-lg transition-colors duration-200 ${
                location.pathname === '/bodega/empacado' 
                  ? 'text-custom-blue' 
                  : 'text-gray-700 hover:text-custom-blue'
              }`}
            >
              <ArchiveBoxIcon className={`h-5 w-5 mr-2 ${location.pathname === '/bodega/empacado' ? 'text-custom-blue' : 'text-gray-700'}`} />
              Cambiar estado a empacado
            </Link>
          )}
          {hasPermission('manage_enviado') && (
            <Link
              to="/bodega/enviado"
              className={`flex items-center p-2 rounded-lg transition-colors duration-200 ${
                location.pathname === '/bodega/enviado' 
                  ? 'text-custom-blue' 
                  : 'text-gray-700 hover:text-custom-blue'
              }`}
            >
              <PaperAirplaneIcon className={`h-5 w-5 mr-2 ${location.pathname === '/bodega/enviado' ? 'text-custom-blue' : 'text-gray-700'}`} />
              Cambiar estado a enviado
            </Link>
          )}
          {hasPermission('manage_export') && (
            <Link
              to="/bodega/exportar"
              className={`flex items-center p-2 rounded-lg transition-colors duration-200 ${
                location.pathname === '/bodega/exportar' 
                  ? 'text-custom-blue' 
                  : 'text-gray-700 hover:text-custom-blue'
              }`}
            >
              <DocumentArrowDownIcon className={`h-5 w-5 mr-2 ${location.pathname === '/bodega/exportar' ? 'text-custom-blue' : 'text-gray-700'}`} />
              Exportar
            </Link>
          )}
        </nav>
      </div> */}

      {/* Contenido principal */}
      <div className="flex-1 p-4">
        <Outlet />
      </div>
    </div>
  );
};

export default Fulfillment; 